module.exports = __webpack_public_path__ + "static/series_w_y_r_h-676a297eb673bdf5ee03a603d3818af8.png";